import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { ILocationsCache } from 'gen/ApiClient';
import React from 'react';

export const LocationsPreloadCacheContext = React.createContext<IPreloadCacheContext<ILocationsCache>>(undefined as any);
